import axios from "axios"
import { CompanyPortalProperties, TranslateFileTablet } from "@models/company"

const ENDPOINT_PREFIX = "/api/snc/"

export async function getCompanyPortalProperties(companyId: string): Promise<CompanyPortalProperties> {
    const resp = await axios.get(ENDPOINT_PREFIX + `companies/${companyId}/portal-properties`)
    return resp.data
}

export const getTablets = (companyId: string) => axios.get<TranslateFileTablet[]>(ENDPOINT_PREFIX + 'tablets', { params: { companyId: companyId } })

export async function getCompanyEmailDomains(companyId: string) {
    const response = await axios.get<string[]>(`/api/admin/companies/${companyId}/email-domains`)
    return response.data
  }